import { Resources, useResource } from "Infrastructure/Translation/Resources";
import { OrderSetupEditWidget } from "Settings/Modules/OrderSetup/Widgets/OrderSetupEditWidget";
import { PageContainer } from "Shared/Components/Container";
import { useParams } from "react-router";

const orderSetupResource = Resources.base.orderSetup.shared;

export const OrderSetupEditPage = () => {
	const { t } = useResource();
	const { marketId, verticalId, orderSetupId } = useParams();

	const paramsMarketId = marketId ? Number(marketId) : undefined;
	const paramsVerticalId = verticalId ? Number(verticalId) : undefined;
	const paramsOrderSetupId = orderSetupId ? Number(orderSetupId) : undefined;

	return (
		<PageContainer
			title={t(orderSetupResource.editPageTitle)}
			description={t(orderSetupResource.editPageDescription)}
		>
			<OrderSetupEditWidget
				marketId={paramsMarketId}
				verticalId={paramsVerticalId}
				orderSetupId={paramsOrderSetupId}
			/>
		</PageContainer>
	);
};
